module.exports = __webpack_public_path__ + "files/2320bcfbed46a4d72b665678a125a2c6.png";